import React from 'react';

import { DisplayText } from '@sg/garnish';

import { useCustomerNameQuery } from '../../GraphQL/AccountMenu.generated';

export const AccountCustomerName = () => {
  const [response] = useCustomerNameQuery();
  const customerName = response.data?.currentCustomer?.firstName;

  return (
    <DisplayText testID="account.menu-customer-name" sizeMatch={['32', '24', '32']}>
      {customerName}
    </DisplayText>
  );
};
